module.exports = __webpack_public_path__ + "static/media/26@3x.c538966d.png";